import { named, optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { IFetchApi, IPageServicesRegistrar } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol, Fetch, PageServicesManagerSymbol } from '@wix/thunderbolt-symbols'
import { TranslationsDefinition } from '@wix/viewer-service-translations/definition'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import type { TranslationsServicePageConfig, TranslationUpdateHandler } from './types'

export const translationsUpdateHandler = withDependencies(
	[named(PageFeatureConfigSymbol, name), Fetch, optional(PageServicesManagerSymbol)],
	(
		{ shouldTakeTranslationsFromManifest }: TranslationsServicePageConfig,
		{ envFetch }: IFetchApi,
		servicesManagerGetter?: IPageServicesRegistrar
	): IModelUpdatesHandlersImplementor<TranslationUpdateHandler> => {
		const servicesManager = servicesManagerGetter?.get()
		const isServiceOpen = servicesManager && servicesManager.hasService(TranslationsDefinition)
		return {
			featureName: name,
			handlers: {
				onAddComponentWithTranslations: async ({ builderCompType, translationsUrl }) => {
					if (!isServiceOpen || !shouldTakeTranslationsFromManifest) {
						return
					}
					const response = await envFetch(translationsUrl)
					const translations = await response.json()
					const translationsService = servicesManager.getService(TranslationsDefinition)
					translationsService.onConfigChange({ translations: { [builderCompType]: translations } })
				},
			},
		}
	}
)
